<template>
  <div class="row">
    <div class="col-md-12 d-flex flex-column justify-content-center">
      <div class="row">
        <div class="col-lg-6 col-md-8 mx-auto">
          <!-- form card login -->
          <div class="card rounded shadow shadow-sm">
            <div class="card-header">
              <h3 class="mb-0">Enter email &amp; password</h3>
            </div>
            <div class="card-body">
              <div class="col-12 alert alert-danger" v-if="error">{{error}}</div>
              <div class="col-12 alert alert-success" v-if="success">{{success}}</div>
              <form
                class="form"
                role="form"
                autocomplete="off"
                id="formLogin"
                novalidate
                @submit.prevent="login"
              >
                <div class="form-group">
                  <label for="uname1">Email</label>
                  <input
                    type="email"
                    class="form-control form-control-lg rounded-0"
                    name="uname1"
                    id="uname1"
                    v-model="email"
                    required
                  />
                  <div class="invalid-feedback">Oops, you missed this one.</div>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input
                    type="password"
                    class="form-control form-control-lg rounded-0"
                    id="pwd1"
                    v-model="password"
                    required
                    autocomplete="new-password"
                  />
                  <div class="invalid-feedback">Enter your password too!</div>
                </div>
                <button
                  type="submit"
                  :disabled="submitted || !valid"
                  class="btn btn-primary btn-lg btn-pulse"
                  id="btnLogin"
                >
                  Login
                  <font-awesome-icon icon="circle-notch" class="fa-spin" v-if="submitted"></font-awesome-icon>
                </button>
              </form>
            </div>
            <!--/card-block-->
          </div>
          <!-- /form card login -->
        </div>
      </div>
      <!--/row-->
    </div>
    <!--/col-->
  </div>
</template>
<script>
import { signIn } from "../../db.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "Login",
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      email: "",
      password: "",
      error: "",
      success: "",
      submitted: false
    };
  },
  computed: {
    valid() {
      return this.email && this.password ? true : false;
    }
  },
  methods: {
    async login() {
      this.submitted = true;
      const result = await signIn(this.email, this.password).catch(err => {
        this.success = "";
        this.error = "Invalid credentials";
      });
      if (result && result.user) {
        this.error = "";
        this.success = "Sucessful Login";
      }

      this.submitted = false;
    }
  }
};
</script>